<template>
	<!-- 新嗨优才大屏 -->
	<div class="newHiYouCaiDiv">
		<div class="hiYouCaiTitleClass"></div>
		<!-- 里面的内容 -->
		<div class="contentDiv">
			<!-- 上面 -->
			<div class="topDivClass">
				<!-- 左边 -->
				<div class="leftDiv">
					<div class="leftTopDiv">
						<leftBackView class="modellingClass" width="80%" height="60px" describeText="用户跟踪情况">
						</leftBackView>
						<solidBarChart style="width: 100%; height: 80%" width='100%' height='100%'
							refName="userSolidBar" :chartXArr="solidXArr" :chartYArr="solidYArr">
						</solidBarChart>
						<!-- <roundChart 
                            style="width: 100%; height: 80%" 
                            :dataArr="userData"
                            :totalText="userSum">
                        </roundChart> -->
					</div>
					<div class="leftBottomDiv">
						<leftBackView class="modellingClass" width="80%" height="60px" describeText="用户列表">
						</leftBackView>
						<div class="seeMoreClass" @click="userBool = true">查看更多 ></div>
					</div>
				</div>
				<!-- 中间 -->
				<div class="middleDiv">
					<!-- 地图 -->
					<div class="newMapClass">
						<hi-map class="hiMapViewClass" :mapTackData="allNational" :provinceArr="nationalX"
							@choiceProvince="choiceProvince">
						</hi-map>
					</div>
				</div>
				<!-- 右边 -->
				<div class="rightDiv">
					<!-- 性别维度 -->
					<div class="genderClass">
						<rightBackView class="rightModellingClass" width="80%" height="60px" describeText="性别维度">
						</rightBackView>
						<div class="allGenderClass">
							<template v-if="genderArr.length">
								<genderView v-for="(item, index) in genderArr" :key="index" width="46%" height="40%"
									:genderImg="genderImgArr[index]" :totalText="item.value" companyName="人"
									:describeText="item.name">
								</genderView>
							</template>
						</div>
					</div>
					<!-- 年龄纬度 -->
					<div class="ageClass">
						<rightBackView class="rightModellingClass" width="80%" height="60px" describeText="年龄维度">
						</rightBackView>
						<div class="allAgeItemClass">
							<ageView v-for="(item, index) in allAgeArr" :key="index"
								:class="index < 3 ? 'oneAgeItemClass' : 'oneAgeItemClass bottomAge'" width="30%"
								height="40%" :describeText="item.name" :totalText="item.value" companyName="人">
							</ageView>
						</div>
					</div>
				</div>
			</div>
			<!-- 下面 -->
			<div class="bottomDivClass">
				<div class="userDiv">
					<div class="userItemClass" v-for="(item, index) in smallUserArr" :key="index">
						<div class="userTopDiv">
							<div class="nameClass">{{item.full_name}} ({{item.nickname}})</div>
							<!-- <div class="followClass">{{item.last_follow_tag}} <span class="seeClass">查看</span> </div> -->
							<div class="followClass" :style="{color: item.last_follow_tag_color}">
								{{item.last_follow_tag}} </div>

						</div>
						<div class="baseInfoClass">
							<div class="infoTextClass">{{item.phone ? item.phone : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.age ? item.age : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.reg_type_v2_name ? item.reg_type_v2_name : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.education_name ? item.education_name : '--'}}</div>
							<div class="lineClass"></div>
							<div class="schoolTextClass writeHearScroll">
								{{item.process_school ? item.process_school : '--'}}</div>
						</div>
						<div class="infoTextClass">最近一次跟进时间：{{item.last_follow_time ? item.last_follow_time : '--'}}
						</div>
						<div class="intentionClass">
							<div class="intentionText writeHearScroll">
								意向国家：{{item.intended_country_name ? item.intended_country_name : '--'}}</div>
							<div class="intentionText writeHearScroll">
								意向专业：{{item.intended_speciality ? item.intended_speciality : '--'}}</div>
						</div>
						<div class="infoTextClass">注册地址：{{item.reg_region}}</div>
						<div class="hengLineClass"></div>
						<div class="caozuoView">
							<div class="caozuoText" @click="getFollowFunc(item.member_id)">查看跟进描述</div>
							<div class="caozuoText" @click="getOrderList(item.member_id)">查看订单{{'('+item.order_num+')'}}
							</div>
							<div class="caozuoText" @click="getMemberDetail(item.member_id)">会员详情</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="content_mobile">
			<div class="middleDiv">
				<!-- 地图 -->
				<div class="newMapClass">
					<hiMapMobile class="hiMapViewClass" :mapTackData="allNational" :provinceArr="nationalX"
						@choiceProvince="choiceProvince">
					</hiMapMobile>
				</div>
				<div class="mobile_button">
					<div class="mobile_bt"  @click="userGzMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">用户跟踪情况></div>
					</div>
					<div class="mobile_bt" @click="userXbMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">性别维度></div>
					</div>
					<div class="mobile_bt" @click="userNlMobile = true">
						<img class="mobile_icon" src="../assets/imgs/gemstoneImg.png" alt="" />
						<div class="mobile_txt">年龄维度></div>
					</div>
				</div>
				<div class="leftBottomDiv">
					<leftBackView class="modellingClass" width="90%" height="40px" describeText="用户列表">
					</leftBackView>
					<div class="seeMoreClass" @click="userBool = true">查看更多 ></div>
				</div>
				<div class="bottomDivClass">
					<div class="userDiv">
						<div class="userItemClass" v-for="(item, index) in smallUserArr" v-if="index<1" :key="index">
							<div class="userTopDiv">
								<div class="nameClass">{{item.full_name}} ({{item.nickname}})</div>
								<!-- <div class="followClass">{{item.last_follow_tag}} <span class="seeClass">查看</span> </div> -->
								<div class="followClass" :style="{color: item.last_follow_tag_color}">
									{{item.last_follow_tag}} </div>
				
							</div>
							<div class="baseInfoClass">
								<div class="infoTextClass">{{item.phone ? item.phone : '--'}}</div>
								<div class="lineClass"></div>
								<div class="infoTextClass">{{item.age ? item.age : '--'}}</div>
								<div class="lineClass"></div>
								<div class="infoTextClass">{{item.reg_type_v2_name ? item.reg_type_v2_name : '--'}}</div>
								<div class="lineClass"></div>
								<div class="infoTextClass">{{item.education_name ? item.education_name : '--'}}</div>
								<div class="lineClass"></div>
								<div class="schoolTextClass writeHearScroll">
									{{item.process_school ? item.process_school : '--'}}</div>
							</div>
							<div class="infoTextClass">最近一次跟进时间：{{item.last_follow_time ? item.last_follow_time : '--'}}
							</div>
							<div class="intentionClass">
								<div class="intentionText writeHearScroll">
									意向国家：{{item.intended_country_name ? item.intended_country_name : '--'}}</div>
								<div class="intentionText writeHearScroll">
									意向专业：{{item.intended_speciality ? item.intended_speciality : '--'}}</div>
							</div>
							<div class="infoTextClass">注册地址：{{item.reg_region}}</div>
							<div class="hengLineClass"></div>
							<div class="caozuoView">
								<div class="caozuoText" @click="getFollowFunc(item.member_id)">查看跟进描述</div>
								<div class="caozuoText" @click="getOrderList(item.member_id)">查看订单{{'('+item.order_num+')'}}
								</div>
								<div class="caozuoText" @click="getMemberDetail(item.member_id)">会员详情</div>
							</div>
				
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="backLevelClass" @click="backLevelClick">返回上一级</div>
		<!-- 添加遮罩层 -->
		<div class="modal-mask" v-if="showModal" @click.self="closeModal"></div>
		<!-- 更多用户列表弹框 -->
		<div class="followDescribe" v-if="userBool && showModal">
			<div class="followTopClass">
				<div></div>
				<div class="followText">更多用户列表</div>
				<img class="followColseClass" src="../assets/imgs/followColse.png" @click="userClick" alt="">
			</div>
			<div class="userDivClass">
				<div :class="(index + 1) % 3 == 0 ? 'moreUserItemClass lastItem' : 'moreUserItemClass'"
					v-for="(item, index) in allUserArr" :key="index">
					<div style="margin: 0 15px">
						<div class="userTopDiv">
							<div class="nameClass">{{item.full_name}} ({{item.nickname}})</div>
							<!-- <div class="followClass">{{item.last_follow_tag}} <span class="seeClass">查看</span> </div> -->
							<div class="followClass" :style="{color: item.last_follow_tag_color}">
								{{item.last_follow_tag}} </div>
						</div>
						<div class="baseInfoClass">
							<div class="infoTextClass">{{item.phone ? item.phone : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.age ? item.age : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.reg_type_v2_name ? item.reg_type_v2_name : '--'}}</div>
							<div class="lineClass"></div>
							<div class="infoTextClass">{{item.education_name ? item.education_name : '--'}}</div>
							<div class="lineClass"></div>
							<div class="schoolTextClass writeHearScroll">
								{{item.process_school ? item.process_school : '--'}}</div>
						</div>
						<div class="infoTextClass">最近一次跟进时间：{{item.last_follow_time}}</div>
						<div class="intentionClass">
							<div class="intentionText writeHearScroll">意向国家：{{item.intended_country_name}}</div>
							<div class="intentionText writeHearScroll">意向专业：{{item.intended_speciality}}</div>
						</div>
						<div class="infoTextClass">注册地址：{{item.reg_region}}</div>
						<div class="hengLineClass"></div>
						<div class="caozuoView">
							<div class="caozuoText" @click="getFollowFunc(item.member_id)">查看跟进描述</div>
							<div class="caozuoText" @click="getOrderList(item.member_id)">查看订单{{'('+item.order_num+')'}}
							</div>
							<div class="caozuoText" @click="getMemberDetail(item.member_id)">会员详情</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pageDivClass">
				<el-pagination class="paginationClass" background layout="prev, pager, next"
					@current-change='cuoTiChange' :current-page="userParams.page" :total="userCount">
				</el-pagination>
			</div>
		</div>
		<!-- 更多订单列表弹框 -->
		<div class="orderDescribe" v-if="orderBool && showModal">
			<div class="followTopClass">
				<div></div>
				<div class="followText">订单列表</div>
				<img class="followColseClass" src="../assets/imgs/followColse.png" @click="orderClick" alt="">
			</div>
			<div class="userDivClass">
				<div :class="(index + 1) % 3 == 0 ? 'moreUserItemClass lastItem' : 'moreUserItemClass'"
					v-for="(item, index) in orderArr" :key="index">
					<div style="margin: 0 15px">
						<div class="userTopDiv">
							<div style="width: 100%; display: flex; margin: 10px 0 10px 0">
								<img class="productImgClass" :src="item.goods_img_url" alt="">
								<div>
									<div class="productClass">{{item.goods_name}}</div>
									<div class="personNameClass">负责人：{{item.teacher_name}}</div>
								</div>
							</div>
							<div class="moneyClass">¥{{item.order_price/100}}</div>
						</div>
						<div class="buyTextClass">用户姓名：{{item.member_name}}</div>
						<div class="buyTextClass">电话：{{item.member_phone}}</div>
						<div class="buyTextClass">购买时间：{{item.create_time}}</div>
					</div>
				</div>
			</div>
			<div class="pageDivClass">
				<el-pagination class="paginationClass" background layout="prev, pager, next"
					@current-change='orderChange' :current-page="orderParams.page" :total="orderCount">
				</el-pagination>
			</div>
		</div>

		<!-- 跟进描述弹框 -->
		<div class="textDescribe" v-if="followBool && showModal">
			<div class="followTopClass">
				<img class="followBackClass" src="../assets/imgs/followBack.png" @click="followClick" alt="">
				<div class="followText">跟进描述</div>
				<img class="followColseClass" src="../assets/imgs/followColse.png" @click="followClick" alt="">
			</div>
			<div class="followInfoClass writeHearScroll">
				<div class="followItemClass" v-for="(item, index) in followArr" :key="index">
					<div class="followTitle">{{item.tag_name}} <span
							class="followTimeClass">({{item.create_time}})</span></div>
					<div class="followInfoText">{{item.follow_content}}</div>
				</div>
			</div>
		</div>
		<!-- 会员详情弹窗 -->
		<div class="memberDetail" v-if="memberBool && showModal">
			<div class="followTopClass">
				<img class="followBackClass" src="../assets/imgs/followBack.png" @click="memberClick" alt="">
				<div class="followText">会员详情</div>
				<img class="followColseClass" src="../assets/imgs/followColse.png" @click="memberClick" alt="">
			</div>
			<div class="bigMember">
				<div class="bigFlex">
					<div class="membername">{{memberInfo.fullname}}{{'('+memberInfo.nickname+')'}}</div>
					<div class="fuze">
						<span style="font-weight: 600;">规划师:{{memberInfo.teacher_name}}</span>
						
					</div>
				</div>
				<div class="memberClass">
					<div class="memberTextClass">{{memberInfo.phone}}</div>
					<div class="memberlineClass">&nbsp;|&nbsp;</div>
					<div class="memberTextClass">{{memberInfo.age ? memberInfo.age : '--'}}</div>
					<div class="memberlineClass">&nbsp;|&nbsp;</div>
					<div class="memberTextClass">{{memberInfo.education ? memberInfo.education :'--'}}</div>
					<div class="memberlineClass">&nbsp;|&nbsp;</div>
					<div class="memberTextClass">{{memberInfo.process_school ? memberInfo.process_school : '--'}}</div>
				</div>
				<div class="memberClass">
					<div class="memberTextClassS">注册地址:</div>
					<div class="memberAddress">{{memberInfo.reg_region}}</div>
				</div>
				<div class="memberLine"></div>
				<div class="memberMiddle">
					<div class="memberClassa">
						<div class="memberTextClassS">意向国家:</div>
						<div class="memberAddress">{{memberInfo.intended_country ? memberInfo.intended_country : '--'}}
						</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">意向专业:</div>
						<div class="memberAddress">
							{{memberInfo.intended_speciality ? memberInfo.intended_speciality : '--'}}</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">计划入学时间:</div>
						<div class="memberAddress">{{memberInfo.plan_enrol_time ? memberInfo.plan_enrol_time : '--'}}
						</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">留学预算:</div>
						<div class="memberAddress">{{memberInfo.budget ? memberInfo.budget : '--'}}</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">在读/毕业院校:</div>
						<div class="memberAddress">{{memberInfo.process_school ? memberInfo.process_school : '--'}}
						</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">在读年级:</div>
						<div class="memberAddress">{{memberInfo.process_grade ? memberInfo.process_grade : '--'}}</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">现学历:</div>
						<div class="memberAddress">{{memberInfo.education ? memberInfo.education : '--'}}</div>
					</div>
					<div class="memberClassa">
						<div class="memberTextClassS">现专业:</div>
						<div class="memberAddress">{{memberInfo.speciality ? memberInfo.speciality : '--'}}</div>
					</div>
				</div>
				<div class="memberLine"></div>
				<div class="memberBottom">
					<div class="memNa">
						<div class="memberTextClassS">客户来源:</div>
						<div class="memberAddress">
							{{memberInfo.reg_channel_v2_name ? memberInfo.reg_channel_v2_name : '--'}}</div>
					</div>
					<div class="memNa">
						<div class="memberTextClassS">邀请人:</div>
						<div class="memberAddress">{{memberInfo.invite_name ? memberInfo.invite_name : '--'}}</div>
					</div>
					<div class="break"></div>
					<div class="memNa">
						<div class="memberTextClassS">跟进状态:</div>
						<div class="memberAddress_un">
							{{memberInfo.last_follow_record ? memberInfo.last_follow_record : '--'}}</div>
						<div class="look_button" @click="getFollowFunc(memberInfo.member_id)">查看</div>
					</div>
					<div class="memNa">
						<div class="memberTextClassd">最后一次跟进时间:</div>
						<div class="memberStatus">{{memberInfo.last_follow_time ? memberInfo.last_follow_time : '--'}}
						</div>
					</div>
					<div class="break"></div>
					<div class="memNa">
						<div class="memberTextClass">GPA:</div>
						<div class="memberStatus">{{memberInfo.gpa ? memberInfo.gpa : '--'}}</div>
					</div>
				</div>
				<div class="memberLine"></div>
				<div class="memberBottom">
					<div class="memNa">
						<div class="memberTextClassS">订单总金额:</div>
						<div class="memberAddress">
							{{memberInfo.order_price_sum/100 ? memberInfo.order_price_sum/100 : '--'}}</div>
					</div>
				</div>
				<!-- <div class="memberBottom">
					<div class="memNa">
						<div class="memberTextClass">跟进状态:</div>
						<div class="memberStatus">{{memberInfo.last_follow_record ? memberInfo.last_follow_record : '--'}}</div>
					</div>
					<div class="memNa">
						<div class="memberTextClassd">最后一次跟进时间:</div>
						<div class="memberStatus">{{memberInfo.last_follow_time ? memberInfo.last_follow_time : '--'}}</div>
					</div>
				</div> -->
				
			</div>
			<img class="orderButton" src="../assets/imgs/orderButton.png" alt=""
				@click="getOrderList(memberInfo.member_id)" />
		</div>
		<!-- 市弹出框 -->
		<div class="cityClass" v-if="cityBool">
			<div class="topCityClass">
				<div class="allCountText">{{provinceText}}总人数 <span class="countTextClass">{{shengCount}}</span> 人</div>
				<img class="followColseClass" @click="cityBool = false" src="../assets/imgs/followColse.png" alt="">
			</div>
			<div class="cityInfoClass">
				<div :class="index % 2 !== 0 ? 'cityItemClass' : 'cityItemClass lightClass'"
					v-for="(item, index) in cityItemArr" :key="index" @click="seeRound(item)">
					<div class="cityNameClass">{{item.belonging_city_name}}</div>
					<div class="cityNameClass">{{item.value}}人</div>
					<div class="seeCityClass">查看分布情况</div>
				</div>
			</div>
		</div>

		<!-- 市图表 -->
		<div class="cityClass" v-show="cityChartBool">
			<div class="topCityClass">
				<img class="followBackClass" src="../assets/imgs/followBack.png" @click="cityChartBool = false" alt="">
				<div class="followText">来源渠道分布</div>
				<img class="followColseClass" src="../assets/imgs/followColse.png" @click="cityChartBool = false"
					alt="">
			</div>
			<div class="cityInfoClass">
				<roundChart1 style="width: 100%; height: 80%" :dataArr="cityData" :totalText="citySum">
				</roundChart1>
			</div>
		</div>
		<!-- 用户跟踪情况弹窗 移动端 -->
		<div class="tj_mobile" v-show="userGzMobile">
		    <div class="TjMobileClass">
		        <div class="followTextMobile">用户跟踪情况</div>
		        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userGzMobile = false" alt="">
		    </div>
		        <template>
		            <solidBarChart 
		                width='300px'
		                height='260px'
		                refName="newSolidBar"
		                :chartXArr="solidXArr"
		                :chartYArr="solidYArr">
		            </solidBarChart>
		        </template>
		</div>
		<!-- 性别维度弹窗 移动端 -->
		<div class="tj_mobile" v-show="userXbMobile">
		    <div class="TjMobileClass">
		        <div class="followTextMobile">性别维度</div>
		        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userXbMobile = false" alt="">
		    </div>
		        <div class="allGenderClass">
		            <template v-if="genderArr.length">
		                <genderView
		                    v-for="(item, index) in genderArr"
		                    :key="index"
		                    width="80%"
		                    height="20%"
		                    :genderImg="genderImgArr[index]"
		                    :totalText="item.value"
		                    companyName="人"
		                    :describeText="item.name">
		                </genderView>
		            </template>
		        </div>
		</div>
		<!-- 年龄维度弹窗 移动端 -->
		<div class="tj_mobile" v-show="userNlMobile">
		    <div class="TjMobileClass">
		        <div class="followTextMobile">年龄维度</div>
		        <img class="followColseClassMobile" src="../assets/imgs/followColse.png" @click="userNlMobile = false" alt="">
		    </div>
		        <div class="allAgeItemClass">
		            <ageView
		                v-for="(item, index) in allAgeArr"
		                :key="index"
		                :class="index < 3 ? 'oneAgeItemClass' : 'oneAgeItemClass bottomAge'"
		                width="40%"
		                height="27%"
		                :describeText="item.name"
		                :totalText="item.value"
		                companyName="人">
		            </ageView>
		        </div>
		</div>
	</div>
</template>

<script>
	import leftBackView from '../../components/modellingLeft.vue'
	import rightBackView from '../../components/modellingRight.vue'
	import genderView from "../../components/genderView.vue";
	import ageView from "../../components/ageView.vue"
	import roundChart from '../../components/roundChart.vue'
	import hiMap from '../../components/newHiMap.vue'
	import roundChart1 from '../../components/roundChart1.vue'
	import solidBarChart from '../../components/solidBarChart.vue'

	//手机端组件
	import hiMapMobile from '../../components/newHiMapMobile.vue'
	import request from '@/utils/request'

	export default {
		components: {
			leftBackView,
			rightBackView,
			genderView,
			ageView,
			roundChart,
			hiMap,
			roundChart1,
			solidBarChart,
			hiMapMobile
		},
		data() {
			return {
				genderArr: [],
				genderImgArr: [
					require('@/assets/imgs/manGender.png'),
					require('@/assets/imgs/womanGender.png'),
					require('@/assets/imgs/unknownGender.png')
				],
				departArr: [],
				staffArr: [],
				provinceText: '',

				allAgeArr: [],
				userBool: false,
				orderBool: false,
				followBool: false,
				memberBool: false, //会员详情弹窗
				planner_id: '',
				regionId: '',
				userCount: 0,
				orderCount: 0,
				smallUserArr: [],
				allUserArr: [],
				followArr: [],
				//订单列表
				orderArr: [],
				//会员详情
				memberInfo: {},
				userParams: {
					planner_id: '',
					page: 1,
					limit: 9,
				},
				orderParams: {
					member_id:'',
					page: 1,
					limit: 9
				},
				userData: [],
				userSum: 0,

				cityData: [],
				citySum: 0,
				allNational: [],
				nationalX: [],

				areaArr: [],
				cityItemArr: [],
				shengCount: 0,
				cityBool: false,
				cityChartBool: false,
				userGzMobile:false,//用户跟踪弹框
				userXbMobile:false,//性别维度弹框
				userNlMobile:false,//年龄维度弹框
				solidXArr: [],
				solidYArr: []
			}
		},
		created() {
			this.planner_id = this.$route.query.userId
			this.regionId = this.$route.query.regionId
			this.userParams.planner_id = this.$route.query.userId
			this.getSaleDataFunc()
			this.getUserDataFunc()
		},
		methods: {
			getSaleDataFunc() {
				request({
					url: `statistics.MemberAnalysis/count?planner_id=${this.planner_id}`,
					method: 'GET',
				}).then(res => {
					if (res.code == 200) {
						this.genderArr = res.data.gender
						this.allAgeArr = res.data.age

						this.userData = res.data.referer.list
						this.userSum = res.data.referer.sum
						this.areaArr = res.data.area

						let provinceArr = []
						this.allNational = res.data.area
						this.allNational.forEach(item => {
							item.value = item.value
							item.name = item.name

							provinceArr.push(item.name)
						});
						this.nationalX = provinceArr

						this.solidXArr = res.data.record.xAxis
						this.solidYArr = res.data.record.series
					}
				})
			},
			getUserDataFunc() {
				request({
					url: `statistics.MemberAnalysis/memberList`,
					method: 'GET',
					data: this.userParams
				}).then(res => {
					if (res.code == 200) {
						console.log(res)
						this.allUserArr = res.data.list
						this.userCount = res.data.count

						if (this.allUserArr.length > 3) {
							this.smallUserArr = this.allUserArr.slice(0, 3)
						} else {
							this.smallUserArr = res.data.list
						}
					}
				})
			},

			backLevelClick() {
				this.$router.push(`newHiYouCai?regionId=${this.regionId}`);
			},
			// 关闭跟进描述
			followClick() {
				this.followBool = false
			},
			// 关闭用户弹框
			userClick() {
				this.userBool = false
			},
			// 关闭订单弹框
			orderClick() {
				this.orderBool = false
			},
			//关闭会员详情弹窗
			memberClick() {
				this.memberBool = false
			},
			cuoTiChange(val) {
				this.userParams.page = val
				this.getUserDataFunc()
			},
			//订单分页
			orderChange(val) {
				this.orderParams.page = val
				this.getOrderList(this.orderParams.member_id);
			},
			// 跟进描述
			getFollowFunc(id) {
				request({
					url: `statistics.MemberAnalysis/memberFollowList?member_id=${id}`,
					method: 'GET',

				}).then(res => {
					if (res.code == 200) {
						this.followArr = res.data.list
						if (this.followArr.length == 0) {
							this.$message.warning('暂无跟进记录')
						} else {
							this.followBool = true
						}
					}
				})
			},
			//订单列表
			getOrderList(id) {
				this.orderParams.member_id = id
				console.log('11111',this.orderParams.member_id)
				request({
					url: `statistics.MemberAnalysis/memberOrderList?member_id=${id}`,
					method: 'GET',
					data: this.orderParams
				}).then(res => {
					this.orderArr = res.data.list
					this.orderCount = res.data.count
					if (this.orderArr.length == 0 || this.orderArr.length == undefined) {
						this.$message.warning('暂无订单记录')
					} else {
						this.orderBool = true
					}
				})
			},
			//会员详情
			getMemberDetail(id) {
				request({
					url: `statistics.MemberAnalysis/memberInfo?member_id=${id}`,
					method: 'GET',
				}).then(res => {
					this.memberBool = true
					this.memberInfo = res.data
					console.log(res.data)
				})
			},
			// 点击省份
			choiceProvince(name) {
				this.areaArr.forEach(item => {
					if (item.name == name) {
						this.cityItemArr = item.children
						this.shengCount = item.value
						this.provinceText = item.fullName

					}
				});
				this.cityBool = true
			},
			// 查看某个城市饼状图
			seeRound(info) {
				this.cityChartBool = true

				this.cityData = info.channel_values
				this.citySum = info.value

				console.log('this.cityData', this.cityData, this.citySum)
			},
			// closeModal() {
			// 	// 关闭所有弹窗
			// 	this.userBool = false;
			// 	this.orderBool = false;
			// 	this.followBool = false;
			// 	this.memberBool = false;
			// 	this.cityBool = false;
			// 	this.cityChartBool = false;
			// },
		},
		computed: {
			showModal() {
				return this.userBool || this.orderBool || this.followBool || this.memberBool || this.cityBool || this
					.cityChartBool;
			}
		},
		watch: {
			showModal(newVal) {
				if (newVal) {
					document.body.style.overflow = 'hidden';
				} else {
					document.body.style.overflow = '';
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.newHiYouCaiDiv {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;
		background-image: url('../assets/imgs/newHiBigBack.png');
		background-size: 100% 100%;
		background-color: #131D27;
	}

	.hiYouCaiTitleClass {
		margin-top: 13px;
		width: 100%;
		height: 53px;
		color: #F3FCFF;
		line-height: 53px;
		letter-spacing: 3px;
	}

	.contentDiv {
		margin: 20px auto 0;
		width: calc(100% - 40px);
		height: calc(100% - 160px);
		// background-color: aquamarine;
	}
	.content_mobile{
		display: none;
	}
	.topDivClass {
		display: flex;
		width: 100%;
		height: 73%;
		// background-color: #757674;
	}

	.bottomDivClass {
		margin-top: 1%;
		display: flex;
		width: 100%;
		height: 25%;
		// background-color: #f9d6d6;
	}

	.userDiv {
		display: flex;
		justify-content: space-between;
		margin: auto;
		width: 88%;
		height: 91%;
		// background-color: #F3FCFF;
	}

	.userItemClass {
		width: 30%;
		height: 100%;
		background-image: url('../assets/imgs/userBack.png');
		background-size: 100% 100%;
		padding: 0 15px;
		// background-color: #67c4e3;
	}

	.userTopDiv {
		margin-top: 1.5%;
		display: flex;
		justify-content: space-between;
	}

	.moneyClass {
		margin-top: 14px;
		font-weight: 600;
		font-size: 18px;
		color: #FFBE51;
	}

	.buyTextClass {
		font-size: 14px;
		color: #FFFFFF;
		text-align: left;
		margin-top: 6px;
	}

	.baseInfoClass {
		margin-top: 0.6%;
		display: flex;
		align-items: center;
		// background-color: rgb(238, 165, 165);
	}

	.infoTextClass {
		display: flex;
		align-items: center;
		font-size: 14px;
		color: #FFFFFF;
		text-align: left;
		// max-width: 100px;
	}

	.schoolTextClass {
		display: flex;
		align-items: center;
		height: 20px;
		overflow-y: auto;
		font-size: 14px;
		color: #FFFFFF;
		text-align: left;
		// min-width: 140px;
		// background-color: #11EFE1;

	}

	.hengLineClass {
		margin-top: 4px;
		height: 2px;
		background-color: #223D6D;
	}

	.caozuoView {
		display: flex;
		// width: 90%;
		margin: auto;
		// background-color: #12F6E9;
	}

	.caozuoText {
		margin-top: 2%;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		// text-align: center;
		color: #12F6E9;
		cursor: pointer;
		// background-color: #e1e4f4;
		padding-bottom: 10px;
	}

	.intentionClass {
		display: flex;
	}

	.intentionText {
		width: 50%;
		height: 20px;
		font-size: 14px;
		color: #FFFFFF;
		text-align: left;
		// overflow-y: auto;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;

	}

	.lineClass {
		margin: auto 4px;
		width: 1px;
		height: 12px;
		background-color: white;
	}

	.nameClass {
		font-weight: 600;
		font-size: 18px;
		color: #FFFFFF;
	}

	.followClass {
		font-size: 14px;
		color: #FFFFFF;
	}

	.seeClass {
		margin-left: 2px;
		font-size: 14px;
		color: #12F6E9;
		cursor: pointer;
	}

	.leftDiv {
		display: flex;
		flex-direction: column;
		width: 30%;
		// height: 100%;
		// background-color: #F3FCFF;
	}

	.leftTopDiv {
		width: 100%;
		height: calc(100% - 65px);
		// background-color: #48b2d5;
	}

	.leftBottomDiv {
		position: relative;
		width: 100%;
		height: 65px;
		// background-color: #cdf5bd;
	}

	.seeMoreClass {
		position: absolute;
		font-size: 20px;
		color: #13FFEE;
		right: 0;
		top: 23px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.modellingClass {
		margin: 20px auto 0 5%;
	}

	.middleDiv {
		width: 40%;
		height: 100%;
		// background-color: #84d9f5;
	}

	.newMapClass {
		width: 100%;
		height: 100%;
		// background-color: #F3FCFF;
	}

	.rightDiv {
		display: flex;
		flex-direction: column;
		width: 30%;
		height: calc(100% - 50px);
	}

	.departmentDivClass {
		margin: 0 4% 0 6%;
		width: 90%;
		height: 37%;
	}

	.allDepartmentClass {
		width: 100%;
		height: calc(100% - 60px);
		// background-color: #F3FCFF;
	}

	.genderClass {
		width: 100%;
		height: 41%;
	}

	.allGenderClass {
		height: calc(100% - 60px);
		// margin-left: 4%;
		display: flex;
		flex-wrap: wrap;
	}

	.ageClass {
		width: 100%;
		height: calc(59% - 20px);
	}

	.rightModellingClass {
		margin: 20px 20px 0 calc(20% - 20px);
	}

	.allAgeItemClass {
		margin-left: 8%;
		width: 92%;
		height: calc(100% - 60px);
		display: flex;
		flex-wrap: wrap;
	}

	.oneAgeItemClass {
		margin-top: 2%;
	}

	.bottomAge {
		margin-top: 5%;
	}

	.backLevelClass {
		margin: auto auto 10px;
		width: 200px;
		font-weight: 600;
		font-size: 20px;
		color: #FFFFFF;
		cursor: pointer;
		z-index: 100;
		// background-color: #F3FCFF;
	}

	.backLevelClass:hover {
		color: #12F6E9;
	}

	.modal-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 500;
		/* 确保在所有弹窗之下 */
		backdrop-filter: blur(2px);
		/* 可选：添加模糊效果 */
	}

	// 订单记录弹出框样式
	.orderDescribe {
		position: fixed;
		top: 10%;
		left: 4.2%;
		width: 86%;
		height: 80%;
		background-color: #01030F;
		border: 10px solid #54A3FF;
		// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
		border-radius: 25px;
		padding: 0 2%;
		z-index: 800;
	}

	.textDescribe {
		position: fixed;
		top: 10%;
		left: 4.2%;
		width: 86%;
		height: 80%;
		background-color: #01030F;
		border: 10px solid #54A3FF;
		// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
		border-radius: 25px;
		padding: 0 2%;
		z-index: 900;
	}

	.followDescribe {
		position: fixed;
		top: 10%;
		left: 4.2%;
		width: 86%;
		height: 80%;
		background-color: #01030F;
		border: 10px solid #54A3FF;
		// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
		border-radius: 25px;
		padding: 0 2%;
		z-index: 600;
	}

	.followTopClass {
		margin-top: 20px;
		display: flex;
		height: 60px;
		justify-content: space-between;
	}

	.followBackClass {
		margin: auto 0;
		width: 41px;
		height: 30px;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.followColseClass {
		margin: auto 0;
		width: 30px;
		height: 30px;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.followText {
		margin: auto;
		font-weight: 600;
		font-size: 38px;
		color: #FFFFFF;
	}

	.followInfoClass {
		margin-top: 10px;
		height: calc(100% - 110px);
		display: flex;
		flex-direction: column;
		overflow-y: auto;

	}

	.followItemClass {
		margin-bottom: 20px;
	}

	.followItemClass:last-child {
		margin-bottom: 0;
	}

	.followTitle {
		font-weight: 600;
		font-size: 18px;
		color: #12F6E9;
		text-align: left;
	}

	.followTimeClass {
		font-weight: 400;
		margin-left: 20px;
		font-size: 15px;
		color: #12F6E9;
	}

	.followInfoText {
		font-size: 16px;
		color: #FFFFFF;
		text-align: justify;
		margin: 4px 20px 0 0px;
	}

	.userDivClass {
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		width: 100%;
		height: calc(100% - 150px);
		// background-color: #12F6E9;
	}

	.moreUserItemClass {
		margin: 0 1% 20px 0;
		width: 32.6%;
		height: 30%;
		background-image: url('../assets/imgs/userBack.png');
		background-size: 100% 100%;
		// padding: 0 15px;
		// background-color: #c4ea87;
	}

	.lastItem {
		margin-right: 0;
	}

	.productImgClass {
		width: 76px;
		height: 46px;
	}

	.productClass {
		width: 250px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		font-weight: 600;
		font-size: 18px;
		color: #FFFFFF;
		margin-left: 10px;
		text-align: left;
	}

	.personNameClass {

		font-size: 14px;
		color: #FFFFFF;
		margin-left: 10px;
		text-align: left;
	}

	.pageDivClass {
		display: flex;
		width: 100%;
		height: 60px;
		// background-color: #FFBE51;
	}

	.paginationClass {
		margin: 4px auto 0;
	}

	.hiMapViewClass {
		width: 100%;
		height: 100%;
	}

	.topCityClass {
		display: flex;
		justify-content: space-between;
		margin: 10px 30px;

	}

	.cityClass {
		position: fixed;
		top: 25%;
		left: 30%;
		width: 40%;
		height: 50%;
		border: 10px solid #54A3FF;
		// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
		border-radius: 25px;
		background-color: #01030F;
		z-index: 1100;
	}

	.cityInfoClass {
		margin: 2%;
		height: calc(94% - 60px);
		// background-color: #12F6E9;
	}

	.allCountText {
		font-weight: 600;
		font-size: 28px;
		color: #FFFFFF;
		text-align: left;
	}

	.countTextClass {
		font-weight: 600;
		font-size: 28px;
		color: #11EFE1;
	}

	.followColseClass {
		width: 30px;
		height: 30px;
		background-size: 100% 100%;
		margin: auto 0;
		cursor: pointer;
	}

	.cityItemClass {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: 10px 30px 0;
		height: 40px;
		background-color: #01030F;
		cursor: pointer;
	}

	.lightClass {
		background: linear-gradient(270deg, rgba(94, 234, 255, 0) 0%, rgba(71, 221, 255, 0.3) 47%, rgba(48, 208, 255, 0) 100%);
	}

	.cityNameClass {
		font-weight: 500;
		font-size: 14px;
		color: #FFFFFF;
		text-align: center;
		min-width: 100px;
	}

	.seeCityClass {
		font-weight: 500;
		font-size: 14px;
		color: #11EFE1;
		cursor: pointer;
	}

	.followBackClass {
		margin: auto 0;
		width: 41px;
		height: 30px;
		background-size: 100% 100%;
		cursor: pointer;
	}

	.followColseClass {
		margin: auto 0;
		width: 30px;
		height: 30px;
		background-size: 100% 100%;
		cursor: pointer;
	}

	//会员详情弹窗样式
	.memberDetail {
		position: fixed;
		top: 10%;
		left: 4.2%;
		width: 86%;
		height: 80%;
		background-color: #01030F;
		border: 10px solid #54A3FF;
		// border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
		border-radius: 25px;
		padding: 0 2%;
		z-index: 700;
	}

	.bigMember {
		position: relative;
		margin-top: 10px;
		height: calc(100% - 110px);
		text-align: left;
	}
	.bigFlex{
		display: flex;
	}
	.membername {
		font-size: 28px;
		font-weight: 600;
		color: #12F6E9;
	}
	.fuze{
		font-size: 18px;
		height: 28px;
		background-color: #ffffff;
		border-radius: 10px;
		margin-left: 20px;
		padding: 2px 17px;
		margin-top: 5px;
	}
	.memberClass {
		margin-top: 0.6%;
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #12F6E9;
		font-weight: 600;
	}

	.memberTextClass {
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #12F6E9;
		text-align: left;
		font-weight: 600;
	}

	.memberTextClassS {
		display: flex;
		font-size: 18px;
		color: #12F6E9;
		text-align: left;
		font-weight: 600;
		margin-right: 10px;
	}

	.memberlineClass {
		font-size: 18px;
		color: #12F6E9;
		font-weight: 600;
		padding: 0 10px;
	}

	.memberLine {
		margin-top: 1.5%;
		height: 1px;
		background: #ffffff;
		opacity: 0.3;
	}

	.memberMiddle {
		display: flex;
		flex-wrap: wrap;
	}

	.memberClassa {
		width: 350px;
		margin-top: 1.5%;
		display: flex;
		margin-right: 3%;
	}

	.memberAddress {
		width: 200px;
		color: #ffffff;
		font-weight: 500;
		font-size: 18px;
		line-height: 28px;
	}

	.memberAddress_un {
		color: #ffffff;
		font-weight: 500;
		font-size: 18px;
		line-height: 28px;
	}

	.memberBottom {
		display: flex;
		flex-wrap: wrap;
	}

	.memNa {
		width: 375px;
		margin-top: 1.5%;
		display: flex;
		margin-right: 1.5%;
	}

	.memberTextClassd {
		width: 150px;
		font-size: 18px;
		color: #12F6E9;
		font-weight: 600;
	}

	.memberStatus {
		color: #fff;
		font-size: 18px;
		width: 200px;
		line-height: 25px;
		text-indent: 10px;
	}

	.break {
		flex-basis: 100%;
		height: 0;
	}

	.look_button {
		width: 62px;
		height: 22px;
		line-height: 25px;
		background-color: #3280FC;
		color: #fff;
		text-align: center;
		margin-left: 5px;
		border-radius: 5px;
		font-size: 12px;
		cursor: pointer;
	}

	.orderButton {
		position: absolute;
		width: 169px;
		height: 61px;
		bottom: 20px;
		left: 45%;
		cursor: pointer;
	}
	@media (max-width:768px){
		.cityClass{
			top: 25%;
			left: 6%;
			width: 79%;
			height: 50%;
			.allCountText{
				font-size: 20px;
			}
			.cityItemClass{
				margin: 10px 0 0;
			}
			.seeCityClass{
				min-width: 80px;
				font-size: 12px;
			}
			.followText{
				font-size: 20px;
			}
		}
		.allAgeItemClass {
			margin-left: 8%;
			width: 92%;
			height: calc(100% - 80px);
			display: flex;
			flex-wrap: wrap;
		}
		// 根元素
		.newHiYouCaiDiv{
		    display: flex;
		    flex-direction: column;
		    width: 100%;
		    height: 100vh;
		    background-image: url('../assets/imgs/mobile_back.png');
		    background-size: 100% 100%;
		    background-color: #131D27;
		}
		.hiYouCaiTitleClass{
			  margin: 3.8% auto 0;
			  display: flex;
			  justify-content: space-between;
			  width: 100%;
		}
		.leftModellingClass{
		    display: flex;
		    width: 139px;
		    height: 71px;
		    background-image: url('../assets/imgs/mobile_back_left.png');
		    background-size: 100% 100%;
		    // background-color: white;
		}
		.topRightModellingClass{
			  display: none;
		}
		.topRightModellingClass_mobile{
		    display: flex;
		    width: 139px;
		    height: 71px;
		    background-image: url('../assets/imgs/mobile_back_right.png');
		    background-size: 100% 100%;
		    // background-color: white;
			  .jiweiClass{
				  display: block;
				  margin: auto;
				  color: #FFFFFF;
				  font-weight: 600;
				  font-size: 8px;
				  transform: rotate(-5deg);
			  }
			  .goJiWeiClass{
				  display: block;
				  margin: auto;
				  color: #FFFFFF;
				  font-weight: 600;
				  font-size: 8px;
				  transform: rotate(-5deg);
			  }
		}
		.leftModellingClass{
			  .jiweiClass{
				  display: none;
			  }
		}
		.jiweiClass{
		  font-weight: 600;
		  font-size: 12px;
		}
		.jiweiClass_mobile{
			  display: block;
			  margin: auto;
			  color: #FFFFFF;
			  font-weight: 600;
			  font-size: 10px;
			  transform: rotate(5deg);
		}
		.contentDiv{
			  display: none;
		}
		.content_mobile{
			  display: block;
			  width: calc(100% - 20px);
			  height: calc(100% - 40px);
			  margin: 30px auto;
			  .middleDiv{
				  width: 90%;
				  height: 100%;
				  margin: auto;
				  .newMapClass{
				      width: 100%;
				      height: 300px; // 或使用百分比如60%
				  }
			  }
		}
		.userDiv{
			height: 95%;
			width: 90%;
		}
		
		.mobile_button{
			  width: 340px;
			  margin: 15px auto;
			  height: 30px;
			  display: flex;
			  justify-content: space-between;
			  flex-wrap: wrap;
			  .mobile_bt{
				  display: flex;
				  width: 32%;
				  height: 30px;
				  background-image: url(../assets/imgs/leftModelling.png);
				  background-size: 125% 100%;
				  background-position: center;
				  .mobile_icon{
					  width: 14px;
					  height: 14px;
				  }
				  .mobile_txt{
					  color: #fff;
					  font-size: 10px;
					  line-height: 20px;
					  text-indent: 2px;
				  }
			  }
		}
		.tj_mobile{
			  display: block;
			  position: fixed;
			  top: 25%;
			  left: 6%;
			  width: 79%;
			  height: 50%;
			  border: 10px solid #54A3FF;
			  // border-image: linear-gradient(136deg, rgba(84, 163, 255, 1), rgba(3, 24, 74, 1), rgba(84, 163, 255, 1)) 10 10;
			  border-radius: 25px;
			  background-color: #01030F;
			  z-index: 110;
			  .TjMobileClass{
				  width: 90%;
				  display: flex;
				  justify-content: space-between;
				  font-weight: 600;
				  font-size: 16px;
				  color: #FFFFFF;
				  margin: 15px auto;
				  .followColseClassMobile{
					  width: 20px;
					  height: 20px;
					  z-index: 999;
				  }
			  }
		}
		.moneyClass{
			font-size: 14px;
		}
		.textDescribe{
			height: 85%;
			left: 2%;
		}
		.orderDescribe{
			height: 85%;
			left: 2%;
		}
		.leftBottomDiv{
			height: 45px;
		}
		.seeMoreClass{
			font-size: 14px;
			top:0;
			right: 10%;
		}
		.userItemClass{
			width: 100%;
		}
		.nameClass{
			font-size: 14px;
		}
		.followClass{
			font-size: 12px;
		}
		.infoTextClass{
			font-size: 12px;
		}
		.intentionText{
			font-size: 12px;
		}
		.caozuoView{
			font-size: 12px;
		}
		.caozuoText{
			margin-top: 1%;
		}
		.followTopClass{
			height: 40px;
			margin-top: 10px;
			.followBackClass{
				width: 26px;
				height: 15px;
			}
			.followText{
				font-size: 25px;
			}
			
		}
		.followColseClass{
			width: 25px;
			height: 25px;
		}
		.memberDetail{
			height: 85%;
			left:2%;
		}
		.membername{
			font-size: 14px;
			// line-height: 35px;
		}
		.fuze{
			width: 100px;
			height: auto;
			font-size: 12px;
			background-color: #ffffff;
			border-radius: 10px;
			margin-left: 0;
			margin-top: 5px;
			padding: 3px 10px;
		}
		.memberTextClass{
			font-size: 12px;
		}
		.memberTextClassS{
			font-size: 12px;
			align-items: center;
		}
		.memberAddress{
			font-size: 12px;
			line-height: 25px;
		}
		.memNa{
			margin-top: 0.5%;
		}
		.memberTextClassd{
			width: 100px;
			font-size: 12px;
		}
		.memberAddress_un{
			font-size: 12px;
		}
		.memberStatus{
			font-size: 12px;
			line-height: 20px;
		}
		.orderButton{
			width: 80px;
			height: 30px;
			bottom: 10px;
			left: 38%;
		}
		.userDivClass{
			height: 80%;
			overflow: auto;
			.moreUserItemClass{
				width: 100%;
				height: 30%;
			}
		}
		.productImgClass{
			width: 32%;
		}
		.productClass{
			width: 200px;
			font-size: 14px;
		}
		.personNameClass{
			font-size: 12px;
		}
		.buyTextClass{
			font-size: 12px;
			margin-top: 0.5%;
		}
		.bigMember {
			position: relative;
			margin-top: 10px;
			height: calc(100% - 110px);
			text-align: left;
			overflow-y: auto;
		}
		.bigFlex{
			display: block;
		}
		.backLevelClass{
			margin: auto auto 2%;
			font-size: 18px;
		}
		.followDescribe{
			left: 2%;
		}
	}
</style>

<style lang="scss">
	@media (max-width:768px){
		.el-pagination.is-background .el-pager li {
			background-color: #081041;
			min-width: 20px !important;
			height: 24px;
			line-height: 24px;
		}
		.el-pagination.is-background button{
			min-width: 20px !important;
			height: 24px;
		}
	}
	.el-pagination.is-background .el-pager li {
		background-color: #081041;
	}
	
	.writeHearScroll {
		&::-webkit-scrollbar {
			width: 6px;
			background: transparent;
		}

		&::-webkit-scrollbar-corner,
		/* 滚动条角落 */
		&::-webkit-scrollbar-thumb,
		&::-webkit-scrollbar-track {
			border-radius: 4px;
		}

		&::-webkit-scrollbar-corner,
		&::-webkit-scrollbar-track {
			/* 滚动条轨道 */
			background-color: #bfc7f3;
			box-shadow: inset 0 0 1px #e1e4f4;
		}

		&::-webkit-scrollbar-thumb {
			/* 滚动条手柄 */
			background-color: #797a7c;
		}
	}
</style>